import { render, staticRenderFns } from "./PublicShareSidebar.vue?vue&type=template&id=7241b4da&scoped=true&"
import script from "./PublicShareSidebar.vue?vue&type=script&lang=js&"
export * from "./PublicShareSidebar.vue?vue&type=script&lang=js&"
import style0 from "./PublicShareSidebar.vue?vue&type=style&index=0&id=7241b4da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7241b4da",
  null
  
)

export default component.exports